import React from "react";

const StepwiseFormWrapper: React.FC = ({ children }) => {
  return <div className="step-wise-form-wrapper">{children}</div>;
};

export default StepwiseFormWrapper;
